<script setup lang="ts">
import { computed } from 'vue'
import defaultAvatar from '../assets/avatar-default.svg'

const props = withDefaults(defineProps<{ src?: string | null; size?: number; text?: string }>(), {
  src: '',
  size: 40,
  text: '',
})

// Fallback order when no avatar is set: the first letter of `text`, otherwise the built-in SVG avatar
const initial = computed(() => (props.text || '').trim().charAt(0).toUpperCase())
const resolved = computed(() => {
  const src = (props.src || '').trim()
  if (src) return src
  return initial.value ? undefined : defaultAvatar
})
</script>

<template>
  <a-avatar :src="resolved" :size="size">{{ initial }}</a-avatar>
</template>
